import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import TermsModal from './TermsModal';
import PrivacyModal from './PrivacyModal';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white mt-20">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        
        {/* Branding */}
        <div>
          <img src="/ssrlogo3.png" alt="myBOQ Logo" className="h-12 mb-4" />
          <p className="text-gray-300 text-sm">
            A trusted estimation & documentation platform for civil engineers and contractors across Maharashtra.
          </p>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-xl font-semibold mb-3">Contact Us</h3>
          <div className="flex items-start gap-3 mb-3">
            <FaPhoneAlt className="text-orange-400 mt-1" />
            <div>
              <p className="font-medium">Call Us</p>
              <p>+91-9112078539</p>
            </div>
          </div>
          <div className="flex items-start gap-3 mb-3">
            <FaEnvelope className="text-orange-400 mt-1" />
            <div>
              <p className="font-medium">Mail Us</p>
              <p>hello@myboq.in</p>
            </div>
          </div>
          <a
            href="/myBOQ_Software_Brochure.pdf"
            download
            className="inline-block mt-4 bg-orange-500 text-white px-4 py-2 rounded hover:bg-white hover:text-orange-500 transition border border-orange-500"
          >
            Download Brochure
          </a>
        </div>

        {/* About */}
        <div>
          <h3 className="text-xl font-semibold mb-3">About myBOQ</h3>
          <p className="text-gray-300 text-sm">
            myBOQ is built by engineers, for engineers. From SSR-compliant estimation to detailed documentation — myBOQ helps you work faster and smarter.
          </p>
        </div>

        {/* Quick Links + Socials */}
        <div>
          <h3 className="text-xl font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-orange-400 transition">Home</Link></li>
            <li><Link to="/features" className="hover:text-orange-400 transition">Features</Link></li>
            <li><TermsModal /></li>
            <li><PrivacyModal /></li>
            <li><Link to="/contact" className="hover:text-orange-400 transition">Contact</Link></li>
          </ul>

          <div className="flex mt-4 space-x-4">
            <a href="#" aria-label="Facebook" className="hover:text-orange-400"><FaFacebookF /></a>
            <a href="#" aria-label="LinkedIn" className="hover:text-orange-400"><FaLinkedinIn /></a>
            <a href="#" aria-label="Twitter" className="hover:text-orange-400"><FaTwitter /></a>
          </div>
        </div>
      </div>

      {/* Bottom Strip */}
      <div className="bg-gray-900 text-gray-400 text-sm py-4">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-2">
          <span>
            © 2025 <a href="https://www.siliconmount.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-white">SILICONMOUNT TECH SERVICES PRIVATE LIMITED</a>
          </span>
          <span>All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
